


































import ShareIcon from '@/components/we-coupons/share-channel/share-icon.vue';
import { biClick } from '@tencent/fit-bi-sdk';
import { MerchantInfo } from '@tencent/wphk-components-wecoupon';
import { pick } from 'lodash-es';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MerchantFavorites } from '@tencent/wphk-components-merchant-favorites';
import { updateFavorites, favoritesStore } from '@/business/favorites-store';
import { jumpChannelPage, JumpType } from './share-channel/business/jump-channel-helper';
import { SpShareHelperParams } from '@tencent/wphk-components-wecoupon/components/share-channel';
import { i18n } from '@/i18n';
import { getCurrencyCodeByType } from '@tencent/wphk-act-base-ui';

// 包含商户logo、信息、优惠总价值的商户信息部分
@Component({
  components: {
    ShareIcon,
    MerchantFavorites,
  },
})

export default class MerchantItemInfo extends Vue {
  @Prop() public showFavorites!: boolean;
  @Prop() public data!: MerchantInfo;
  @Prop() public isShowChannelShare?: Boolean;
  @Prop() public isSupportJumpChannel?: Boolean;  // 从isShowChannelShare里划分出来：分享 跟 跳转channel独立
  @Prop() public openFrom!: JumpType;
  subTplInfo = [{
    id: 'subc.wecoupon_online_notify',
    tplId: 'Vp0eojT1lEUceQjBZPwMy0LlGMCSaC4_hEDmCdDr9Vs',
  }];
  public get isShowDiscount() {
    return this.data.totalValue !== 0;
  }
  public get hideValue() {
    return this.data.totalValue === 0 && favoritesStore.isFavoritesTab;
  }
  /** 单币种 */
  get isSingleCurrencyType() {
    return !this.data.currencyType || this.data.currencyType.split('|').length === 1;
  }
  /** 商户描述 */
  get merchantDesc() {
    if (!this.isSingleCurrencyType) {
      // 多币种
      return i18n('共有x張優惠券', { cnt: this.data.totalCnt });
    };
    if (this.isShowDiscount) {
      // 总值非 0
      const currencyCode = getCurrencyCodeByType(this.data.currencyType);
      return `${i18n('优惠总值')} <span>${currencyCode}${this.data.totalValue}</span>`;
    };
    if (!favoritesStore.isFavoritesTab) {
      // 非收藏 tab
      return `<span>${i18n('折扣优惠')}</span>`;
    }
    return '';
  }
  favoritesChange(data) {
    updateFavorites(data.spId);
  }
  get shareParams(): SpShareHelperParams {
    return { ...pick(this.data, ['spId', 'spLogo', 'spName']), adtagPrefix: 'd' };
  }
  goChannelPage() {
    if (!this.isSupportJumpChannel) {
      return;
    }
    biClick('info_module.share_title|点击商户标题跳转');
    const { spId } = this.data;
    jumpChannelPage({ spId, type: this.openFrom });
  }
}
